import React from 'react';
import { OpenAPIObject } from 'openapi3-ts';

import fourDotSix from './4.6/corex.yml';
import fiveDotZero from './5.0/corex.yml';
import fiveDotOne from './5.1/corex.yml';
import fiveDotTwo from './5.2/corex.yml';
import fiveDotThree from './5.3/corex.yml';
import sixDotZero from './6.0/corex.yml';
import sixDotOne from './6.1/corex.yml';
import sixDotTwo from './6.2/corex.yml';
import sixDotThree from './6.3/corex.yml';
import sixDotFour from './6.4/corex.yml';

export interface CoreExchangeOpenApiSchemas {
  '4.6': OpenAPIObject;
  '5.0': OpenAPIObject;
  '5.1': OpenAPIObject;
  '5.2': OpenAPIObject;
  '5.3': OpenAPIObject;
  '6.0': OpenAPIObject;
  '6.1': OpenAPIObject;
  '6.2': OpenAPIObject;
  '6.3': OpenAPIObject;
  '6.4': OpenAPIObject;
}

const schemas: CoreExchangeOpenApiSchemas = {
  '4.6': fourDotSix as unknown as OpenAPIObject,
  '5.0': fiveDotZero as unknown as OpenAPIObject,
  '5.1': fiveDotOne as unknown as OpenAPIObject,
  '5.2': fiveDotTwo as unknown as OpenAPIObject,
  '5.3': fiveDotThree as unknown as OpenAPIObject,
  '6.0': sixDotZero as unknown as OpenAPIObject,
  '6.1': sixDotOne as unknown as OpenAPIObject,
  '6.2': sixDotTwo as unknown as OpenAPIObject,
  '6.3': sixDotThree as unknown as OpenAPIObject,
  '6.4': sixDotFour as unknown as OpenAPIObject,
};

const OpenAPICoreExchangeContext =
  React.createContext<CoreExchangeOpenApiSchemas>(schemas);

export const { Consumer, Provider } = OpenAPICoreExchangeContext;

export const CoreExchangeOpenAPIProvider: React.FC<React.PropsWithChildren> = (
  props,
) => {
  return <Provider value={schemas}>{props.children}</Provider>;
};

export default OpenAPICoreExchangeContext;
